(function () {
	var myVar = setInterval(timer, 300);
	function timer() {
		if (window.jQuery) {
			SwellConfig.Link.initializeLinks(".swell-btn");
			SwellConfig.LocalStorage.initializeLocalStorage();
			$(document).ready(function () {
				$(document).on("swell:setup", function() {
					$(".swell-post-checkout").css("display", "flex");
				    if (window.location.href.indexOf("refer") > -1) {
				    	$("body").addClass("swell-refer");
				    }
					Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
					SwellConfig.RedemptionCart.appendDiscounts();
					SwellConfig.Campaign.authenticate();
					SwellConfig.Redemption.appendRedemptions();
					swellAPI.refreshEmbeds();
// 					$(".swell-redemption-list .swell-redemption:last-child").detach();
					SwellConfig.Tier.initializeDummyTier();
					SwellConfig.Tier.initializeCustomTierProperties();
					SwellConfig.Tier.initializeTiers();
					SwellConfig.Tier.initializeTierSlider();
					$(".swell-referral-loader").hide();
				});

				$('body').on('click', '.swell-post-checkout .swell-referral-back-link', function () {
					$(".swell-post-checkout").hide();
				});

				$('body').on('click', '.swell-btn', function () {
					$('body').removeClass("unloading");
				});

				$('body').on('click', '.swell-redeem-cart', function () {
					$(".swell-redeem-cart.button").html("<img class='spinner-icon-apply' src=//cdn.shopify.com/s/files/1/0815/5095/t/66/assets/swell-loader-white.svg?v=6297613124871348540>");
					var redemptionOptionSelect = $(".swell-select-box");
					var value = redemptionOptionSelect.val();
					if(value==-1) {
						spapi.$.confirm({
							title: "Oops!",
							content: "Please select a value to apply.",
							type: "red",
							typeAnimated: true,
							useBootstrap: false,
							boxWidth: "400px",
							buttons: {
								ok: {
									text: "Ok",
									action: function () {
									}
								}
							}
						});
						$(".swell-redeem-cart.button").html("APPLY");
						return;
					}

					var selection = swellAPI.findActiveRedemptionOptionById(value);
					$(".swell-modal-custom-cart #swell-reward-heading").html("<h4>" + selection.name + "</h4>");

					var onSuccess = function (redemption) {
						$(".swell-modal-custom-cart #swell-reward-intro").html("<p>" + redemption.redemptionOption.reward_intro + "</p>");
						$(".swell-modal-custom-cart #swell-coupon-code").html(redemption.couponCode);
						$(".swell-modal-custom-cart #swell-coupon-code-copy").html("<p>Simple copy and paste the coupon code at checkout.</p>");
						$(".swell-modal-custom-cart").css("display", "flex");
						$(".swell-redeem-cart.button").html("APPLY");
					};

					var onError = function (err) {
						$(".swell-modal-custom-cart #swell-reward-intro").hide();
						$(".swell-modal-custom-cart #swell-coupon-code").hide();
						$(".swell-modal-custom-cart #swell-redemption-error").html("Sorry, you don't have enough points for this reward.");
						$(".swell-modal-custom-cart").css("display", "flex");
						$(".swell-redeem-cart.button").html("APPLY");
					};
					swellAPI.makeRedemption({
						redemptionOptionId: redemptionOptionSelect.val()
					},
					onSuccess,
					onError
					);
				});

				$("body").on('click', '.swell-modal-custom-cart .close', function(event) {
					$('.swell-modal-custom-cart').css("display", "none");
					return false;
				});

			});
			stop();
		}
	}
	function stop() {
		clearInterval(myVar);
	}
}).call(this);

(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Campaign = {
      opts: {
        templates: {
          campaign: "<li class='swell-campaign'><div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <i class='swell-campaign-icon <%= campaign.icon %>'> <span class='path1'></span> <span class='path2'></span> </i> <h4 class='swell-campaign-heading'><%= campaign.reward_text %></h4> <p class='swell-campaign-title'><%= campaign.title %></p></div></li>"
        }
      },
      authenticate: function() {
        if (spapi.authenticated) {
            $(".swell-campaign .swell-campaign-content").css("cursor", "pointer");
        }
      }
    };
}).call(this);

(function () {
	window.SwellConfig = window.SwellConfig || {};
	SwellConfig.Redemption = {
		appendRedemptions: function() {
			var redemptions = spapi.activeRedemptionOptions;
			var	sorted_redemptions = redemptions.sort(function(a,b) { return a.amount - b.amount });

			var index = 0;
			sorted_redemptions.forEach(function (redemption)
			{
				if (redemption.discount_type == "fixed_amount") {
					index++;
					
					if (index < sorted_redemptions.length - 1) {
						$('.swell-redemption-list').append('<li class="swell-redemption swell-redemption-link" data-redemption-option-id='+redemption.id+'> <h2 class="swell-redemption-heading">'+redemption.name+'</h2> <p class="swell-redemption-text">'+redemption.cost_text+'</p> </li>');
					} else {
						if (index % 2 == 1) {
							$('.swell-redemption-list').append('<li class="swell-redemption swell-redemption-link swell-middle-place" data-redemption-option-id='+redemption.id+'> <h2 class="swell-redemption-heading">'+redemption.name+'</h2> <p class="swell-redemption-text">'+redemption.cost_text+'</p> </li>');
						} else {
							$('.swell-redemption-list').append('<li class="swell-redemption swell-redemption-link" data-redemption-option-id='+redemption.id+'> <h2 class="swell-redemption-heading">'+redemption.name+'</h2> <p class="swell-redemption-text">'+redemption.cost_text+'</p> </li>');
						}
					}
				}
			}); 
		}
	}
}).call(this);

(function () {
	window.SwellConfig = window.SwellConfig || {};
	SwellConfig.RedemptionCart = {
		appendDiscounts: function() {
			if(typeof (spapi) != "undefined") {
				$(".swell-cart-redemptions .swell-point-balance").html(spapi.customer.points_balance);
				var redemptions = spapi.activeRedemptionOptions;
				redemptions.forEach(function (redemption)
				{
					if (redemption.discount_type == "fixed_amount") {
						$('.swell-select-box').append('<option value="'+redemption.id+'">' + redemption.name + ' (' + redemption.cost_text + ')</option>');
					}
				});	
			}
		}
	}
}).call(this);

(function () {
	window.SwellConfig = window.SwellConfig || {};
	SwellConfig.Tier = {
		getCustomerTierId: function () {
			var customer_tier, intro_tier, tiers;
			customer_tier = spapi.customer.vip_tier;
			tiers = spapi.activeVipTiers;
			if (customer_tier) {
				return customer_tier.id;
			} else {
				intro_tier = $.grep(tiers, function (e) {
					return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
				});
				if (intro_tier.length > 0) {
					return intro_tier[0].id;
				} else {
					return null;
				}
			}
		},
		getCustomerTierRank: function () {
			var customer_tier, intro_tier, rank, tiers;
			customer_tier = spapi.customer.vip_tier;
			tiers = spapi.activeVipTiers;
			if (customer_tier && customer_tier.id) {
				rank = $.grep(tiers, function (e) {
					return e.id === customer_tier.id;
				})[0].rank;
				return rank;
			} else {
				intro_tier = $.grep(tiers, function (e) {
					return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
				});
				if (intro_tier.length > 0) {
					return intro_tier[0].rank;
				} else {
					return null;
				}
			}
		},
		getTierByRank: function (rank) {
			var tiers;
			tiers = spapi.activeVipTiers;
			return $.grep(tiers, function (e) {
				return e.rank === rank;
			})[0];
		},
		setupCustomerTierStatus: function() {
			var columnLength, customer_tier_id, customer_tier_rank, data_id, next_tier, spend_required, current = 0;
	        customer_tier_id = SwellConfig.Tier.getCustomerTierId();
          	customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
          	if(customer_tier_id) {
            	next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
          	} else {
            	next_tier = SwellConfig.Tier.getTierByRank(0);
          	}

          	columnLength = $(".swell-vip-tiers-container .swell-vip-tier").length;

          	if (customer_tier_id == spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
            	$(".swell-vip-tiers-container .swell-vip-tier:nth-child(" + columnLength + ")").prepend("<span class='swell-current-status-tier'>Current Status</span>");
          		$(".swell-vip-tiers-container .swell-vip-tier:nth-child(" + columnLength + ")").addClass("swell-current-status");
          	} else {
            	for (counter = 1; counter < columnLength; counter++) {
                	data_id = $(".swell-vip-tiers-container .swell-vip-tier:nth-child(" + counter + ") ").data("tier-id");
                	if (data_id == customer_tier_id) {
                    	$(".swell-vip-tiers-container .swell-vip-tier:nth-child(" + (counter) + ")").prepend("<span class='swell-current-status-tier'>Current Status</span>");
                    	$(".swell-vip-tiers-container .swell-vip-tier:nth-child(" + (counter) + ")").addClass("swell-current-status");
                    	
                    	if(spapi.customer.vip_tier_stats_needed.purchases_needed == 1) {
                    		$(".swell-vip-tiers-container .swell-vip-tier:nth-child(" + (counter+1) + ")").prepend("<span class='swell-current-status-tier swell-next-tier'> Spend $"+(spapi.customer.vip_tier_stats_needed.amount_cents_needed/100)+" more or make "+spapi.customer.vip_tier_stats_needed.purchases_needed+" purchase for "+next_tier.name+".</span>");
                    	} else {
                    		$(".swell-vip-tiers-container .swell-vip-tier:nth-child(" + (counter+1) + ")").prepend("<span class='swell-current-status-tier swell-next-tier'> Spend $"+(spapi.customer.vip_tier_stats_needed.amount_cents_needed/100)+" more or make "+spapi.customer.vip_tier_stats_needed.purchases_needed+" purchases for "+next_tier.name+".</span>");
                    	}
                	}
            	}
          	}	 
		},
		initializeDummyTier: function() {
          var k, len, tier, tiers;
          tiers = spapi.activeVipTiers;
          for (k = 0, len = tiers.length; k < len; k++) {
              tier = tiers[k];
              tier.rank += 1;
          }
          return tiers.unshift({
              id: -1,
              rank: 0,
              name: "Create an Account",
              point_multiplier: "1x",
              swellrequiredAmountSpent: "$0",
              swellrequiredAmountSpentCents: 0,
              swellrequiredPointsEarned: 0,
              swellrequiredPurchasesMade: 0,
              swellrequiredReferralsCompleted: 0
          });
      	},
		initializeCustomTierProperties: function () {
			spapi.activeVipTiers[0].spendPoints = "Create an Account",
			spapi.activeVipTiers[0].multiplier = "1x",
			spapi.activeVipTiers[0].benefit1 = "Point Multipliers",
			spapi.activeVipTiers[0].benefit2 = "",
			spapi.activeVipTiers[0].benefit3 = "",
			spapi.activeVipTiers[0].benefit4 = "",
			spapi.activeVipTiers[0].benefit5 = "",

			spapi.activeVipTiers[1].spendPoints = "5 Purchases ($500)",
			spapi.activeVipTiers[1].multiplier = "1.25x",
			spapi.activeVipTiers[1].benefit1 = "Point Multipliers",
			spapi.activeVipTiers[1].benefit2 = "Exclusive Offers",
			spapi.activeVipTiers[1].benefit3 = "First look at new products",
			spapi.activeVipTiers[1].benefit4 = "Engagement regarding new colors, etc.",
			spapi.activeVipTiers[1].benefit5 = "",

			spapi.activeVipTiers[2].spendPoints = "10 Purchases ($1000+)",
			spapi.activeVipTiers[2].multiplier = "1.5x",
			spapi.activeVipTiers[2].benefit1 = "Point Multipliers",
			spapi.activeVipTiers[2].benefit2 = "Exclusive Offers",
			spapi.activeVipTiers[2].benefit3 = "First look at new products",
			spapi.activeVipTiers[2].benefit4 = "Engagement regarding new colors, etc.",
			spapi.activeVipTiers[2].benefit5 = "Free pair of insoles (as a coupon)"
		},
		initializeTiers: function (containerSelector) {
			tiers = spapi.activeVipTiers;
			var counter = 1, tier_name, id;          

			tiers.forEach(function(tier) {
				if (typeof tier.spendPoints != "undefined") {
					$(".swell-vip-tiers-container").append('<div class="swell-vip-tier" data-tier-id='+tier.id+'> <h2 class="swell-heading swell-heading-vip-tier">'+tier.spendPoints+'</h2> <h1 class="swell-multiplier">'+tier.multiplier+'</h1> <p class="swell-text">'+tier.benefit1+'</p> <p class="swell-text">'+tier.benefit2+'</p> <p class="swell-text">'+tier.benefit3+'</p> <p class="swell-text">'+tier.benefit4+'</p> <p class="swell-text">'+tier.benefit5+'</p> </div>');
					counter++;
				}
          	});
			
			if(spapi.authenticated) {
				SwellConfig.Tier.setupCustomerTierStatus();
			}
		},
		initializeTierSlider: function() {
			$(".swell-vip-tiers-container").slick({
				dots: true,
				arrows:true,
				nextArrow: '<div class="icon-holder right-arrow"><i class="swell-icon-chevron-thin-right slick-arrows"></i></div>',
				prevArrow: '<div class="icon-holder left-arrow"><i class="swell-icon-chevron-thin-left slick-arrows"></i></div>',
				infinite: true,
				speed: 300,
				slidesToScroll:1,
				slidesToShow: 3,
				responsive: [
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
				]
			});
		}
	};
}).call(this);

// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };
}).call(this);

// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && (window.location.pathname === '/account' || window.location.pathname === '/')) {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

$(document).ready(function(){
  $('.swell-vip-tier:nth-child(0)').remove();
});